import CustomButton from "components/CustomButton";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useGlobalContext } from "store/contexts/globalContext";
import ManageSurveyDialog from "components/ManageSurveyDialog";

export default () => {
  const history = useHistory();
  const params = useParams();
  const { microsoftConfigureTab } = useGlobalContext();
  const [dialog, setDialog] = useState(false);

  const goToManageSurvey = () => {
    if (!microsoftConfigureTab)
      return history.push(`/teams/${params.teamId}/wellness/survey/manage`);

    setDialog(true);
  }

  return (
    <>
      <div>
        <CustomButton
          onClick={goToManageSurvey}
        >
          Manage Survey
        </CustomButton>
      </div>
      <ManageSurveyDialog dialog={dialog} setDialog={setDialog} />
    </>
  );
};
